import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { i18n } from '@/boot/i18n';
import { FIB } from '@/config/constants';
var QUESTION_TYPE = FIB.QUESTION_TYPE;
import { makeQuestionScreen, addSubmitQuestion } from "./_utils";
import { selectBasedOnCounts, select } from "./_drilldownQuestionUtils";
export default {
  type: QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN,
  requiresTransaction: false,
  selectBasedOnCounts: selectBasedOnCounts,
  select: select,

  /**
   * Renders a Drilldown Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", makeQuestionScreen(context, [{
                id: 'question' + context.question.id,
                type: 'fib-comments',
                required: context.question.required,
                label: '',
                props: {
                  label: i18n.t('questions.comments.enter')
                }
              }], context.question, {
                title: context.question.text
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var response = context.response;

    if (!response.answers.length || !response.answers[0].value) {
      return null;
    }

    return {
      text: response.answers[0].value,
      mutateSubmit: function mutateSubmit(submit) {
        addSubmitQuestion(submit, response, {
          text: this.text
        });
      }
    };
  }
};